/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
enum FirestoreCollections {
  /** Collections */
  admins = 'Admins',
  companies = 'Companies',
  subscriptions = 'Subscriptions',
  contacts = 'Contacts',
  numbers = 'Numbers',
  notifications = 'Notifications',
  jobs = 'Jobs',
  users = 'Users',
  sms = 'SMS',
  smsConversations = 'SmsConversations',
  ai = 'AI',
  plans = 'Plans',
  feedbacks = 'Feedbacks',
  domains = 'Domains',
  scenarios = 'Scenarios',
  tasks = 'Tasks',
  tags = 'Tags',
  logs = 'Logs',
  voicemails = 'Voicemails',
  calls = 'Calls',
  costs = 'Costs',
  synchros = 'Synchros',
  e2eRuns = 'E2ERuns',

  /** Subcollections */
  // Numbers subcollections
  numbers_history = 'history',
  // Users subcollections
  users_history = 'history',
  users_files = 'files',
  // Plans and Subscriptions subcollections
  plans_leedbucks_rates_history = 'leedbucks_rates_history',
  subscriptions_leedbucks_rates_history = 'leedbucks_rates_history',
  subscriptions_leedbucks_credits_history = 'leedbucks_credits_history',
}

export { FirestoreCollections };
